export default __webpack_public_path__ + "static/media/Amazone.7788f335.png";